import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    title: PropTypes.string,
    description: PropTypes.string,
    isIndexable: PropTypes.bool,
  },
  {},
);
